import { Selector, createSelector } from "@reduxjs/toolkit";
import { RootState } from "../reducers";
import { CatalogueReducerState } from "./catalogueReducers";

export const selectSelectedCategory: Selector<
  RootState, CatalogueReducerState['selectedCategory']
> = createSelector(
  [
    (state: RootState) => state.catalogue.selectedCategory,
  ],
  (
    selectedCategory,
  ) => {
    return selectedCategory;
  },
);

